import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const TelephoneFillIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40926 0.540443C2.58351 0.366173 2.79282 0.230946 3.02332 0.143735C3.25381 0.0565226 3.50022 0.0193188 3.74618 0.0345913C3.99215 0.0498638 4.23206 0.117263 4.44999 0.232319C4.66793 0.347374 4.85891 0.507456 5.01026 0.701943L6.79632 2.99907C7.12464 3.41982 7.24045 3.96913 7.11082 4.48657L6.56576 6.66788C6.53741 6.78107 6.53886 6.89966 6.56995 7.01213C6.60105 7.12459 6.66073 7.22708 6.7432 7.30963L9.1912 9.75657C9.27375 9.83903 9.37624 9.89872 9.4887 9.92981C9.60116 9.96091 9.71976 9.96235 9.83295 9.93401L12.0132 9.38894C12.2689 9.32507 12.5358 9.3202 12.7937 9.37469C13.0516 9.42917 13.2937 9.54159 13.5018 9.70344L15.7989 11.4895C16.6244 12.1313 16.7009 13.3521 15.9614 14.0905L14.9308 15.1211C14.1945 15.8574 13.0927 16.1815 12.0653 15.8203C9.43707 14.8952 7.05085 13.3903 5.08357 11.4173C3.11013 9.45009 1.60489 7.06386 0.67951 4.43557C0.31826 3.40813 0.642323 2.30632 1.37864 1.56894L2.40926 0.539381V0.540443Z",
    fill: color
  }));
};
export default TelephoneFillIcon;